import {createSelector} from '@ngrx/store';
import {appGroupEntityAdapter as EntityAdapter, AppGroupState as EntityState} from "./app-group.state";
import {AppGroup as Entity} from './app-group.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.appGroup;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
    createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
    selectState,
    (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntity = createSelector(selectState, (state: EntityState) => state.currentEntity);

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);

export const AppGroupSelectors = {
    selectAll,
    selectById,
    isLoading,
    hasErrors,
    findByCorrelationId,
    currentEntity,
    totalPageable
};
